module.exports = __webpack_public_path__ + "img/proxmox.338811ea.svg";